import React, { useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import CustomDialog from "../utils/CustomDialog";
import { useIsMobile } from "../utils/hooks";
import posthog from "posthog-js";

const CalculatorDialog = ({ calculator, onClose }) => {
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(true);
  const open = !!calculator;

  if (!open) return null;

  const handleIframeLoad = () => {
    setLoading(false);
    posthog.capture('calculators:detail_view', { property: calculator.name });
  };

  const handleDialogClose = () => {
    setLoading(true); // Reset loading para la próxima vez
    onClose();
  };

  return (
    <CustomDialog
      open={open}
      onClose={handleDialogClose}
      title={`Calculadora: ${calculator.name}`}
      size="lg"
      heigth={600}
      fullScreen={isMobile}
    >
      <Box sx={{ height: "100%", width: "100%", position: "relative" }}>
        {loading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              zIndex: 1
            }}
          >
            <CircularProgress size={40} />
            <Typography variant="body2" sx={{ mt: 2, color: "text.secondary" }}>
              Cargando calculadora...
            </Typography>
          </Box>
        )}
        <iframe
          src={`https://qxmd.com/calculate/${calculator.id}`}
          style={{
            width: "100%",
            height: "560px",
            border: "none",
            opacity: loading ? 0 : 1,
            transition: "opacity 0.3s ease-in-out"
          }}
          title={calculator.name}
          onLoad={handleIframeLoad}
        />
      </Box>
    </CustomDialog>
  );
};

export default CalculatorDialog; 